import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getLiteraryDesignUnitVisual } from "../../data/visuals";

import styles from "./viz-literary-design-unit.css";

import type { LiteraryDesignUnitVisualData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-viz-literary-design-unit")
export class VizLiteraryDesignUnit extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: LiteraryDesignUnitVisualData;

  @property({ attribute: "excluded-key-paths" })
  excludedKeyPaths?: string;

  render() {
    if (!this.data) return;

    const { usx, caption } = this.data;

    return html`
      <bp-literary-design
        usx="${usx}"
        .excludedKeyPaths=${this.excludedKeyPaths}
      >
        ${caption &&
        html` <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption> `}
      </bp-literary-design>
    `;
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getLiteraryDesignUnitVisual(this.arcId)
      .then(({ data }) => {
        const parser = new DOMParser();
        const usx = parser.parseFromString(`${data.usx}`, "text/xml");
        this.data = { ...data, usx: usx.documentElement.outerHTML };
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-literary-design-unit": VizLiteraryDesignUnit;
  }
}
